// Privacy operations (platform): the DSAR queue + default retention policies, via
// compliance-service. Platform-gated server-side.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface PrivacyRequest {
  id: string;
  tenant_id: string;
  user_id: string;
  request_type: string;
  status: string;
  details?: Record<string, unknown>;
  handled_by?: string | null;
  created_at: string;
  updated_at: string;
}

export interface RetentionPolicy {
  id: string;
  data_category: string;
  retention_days: number | null;
  legal_hold: boolean;
  updated_at: string;
}

export const getPrivacyRequests = (status?: string) =>
  axios
    .get<{ requests: PrivacyRequest[] | null }>(`${API_V1}/compliance/platform/privacy-requests`, {
      params: status ? { status } : {},
    })
    .then((r) => r.data.requests ?? []);

export const setRequestStatus = (id: string, status: string) =>
  axios
    .patch<PrivacyRequest>(`${API_V1}/compliance/platform/privacy-requests/${id}`, { status })
    .then((r) => r.data);

// Build the export bundle for an access/export/portability request (marks completed).
export const fulfilExport = (id: string) =>
  axios
    .post<PrivacyRequest>(`${API_V1}/compliance/platform/privacy-requests/${id}/fulfil`)
    .then((r) => r.data);

// Download the assembled export bundle (JSON) and save it.
export const downloadExport = async (id: string) => {
  const res = await axios.get(`${API_V1}/compliance/platform/privacy-requests/${id}/export`, {
    responseType: 'blob',
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `data-export-${id}.json`;
  a.click();
  URL.revokeObjectURL(url);
};

export const getRetentionPolicies = () =>
  axios
    .get<{ policies: RetentionPolicy[] | null }>(`${API_V1}/compliance/platform/retention-policies`)
    .then((r) => r.data.policies ?? []);

export const upsertRetentionPolicy = (input: {
  data_category: string;
  retention_days: number | null;
  legal_hold: boolean;
}) =>
  axios
    .put<RetentionPolicy>(`${API_V1}/compliance/platform/retention-policies`, input)
    .then((r) => r.data);
